<template>
  <modal name="mensaje" :scrollable="true" :height="'auto'">
    <div class="container p-4">
        <div class="text-center">
            <img v-if="Icon == 2" src="../../../assets/img/icon-cancel.png" alt="" height="120px">
            <img v-if="Icon == 1" src="../../../assets/img/icon-success.png" alt="" height="120px">
            <h3>{{ Title }}</h3>
            <p class="p-2"> {{ Text }}</p>
            <button :class="ClassButton" style="border-radius: 15px;" @click="actionButton">Continuar</button>
        </div>
    </div>
    </modal>
</template>

<script>
export default {
    props:{
        Icon: Number,
        Title: String,
        Text: String,
        ClassButton: String,
        actionButton: Function
    },
    methods:{
        // actionButton(){
        //     this.$modal.hide('mensaje')
        // }
    }
}
</script>